<script setup lang="ts">
import { dateZhCN, NConfigProvider, NDialogProvider, NMessageProvider, zhCN } from 'naive-ui';
</script>

<template>
  <!--
    ★ 后台用浅色主题：运营的主活儿是"读表格核对数字"，深色下金额/状态的对比度反而差；
      而且后台不对买家公开，不需要跟 apps/web 的品牌暗色保持一致。
    ★ 语言包只挂 UI 组件的（日期选择器、分页文案），不做业务多语言：
      C13（后台 i18n）在迭代二排期，见开发计划文档 §迭代二。
  -->
  <n-config-provider :locale="zhCN" :date-locale="dateZhCN">
    <n-message-provider>
      <n-dialog-provider>
        <RouterView />
      </n-dialog-provider>
    </n-message-provider>
  </n-config-provider>
</template>
